var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-sms-input"},[_c('common-sms-input',{attrs:{"sms-verification-props":_vm.smsVerificationProps},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }